<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AcN2Do/tc-custom/9781480439771.jpg?1705606111676" alt="This image is the cover for the book Return to Night"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Return to Night
      </h1>
      <p class="bookDescription body article font2">
        <b>Winner of an MGM prize:</b> <b>A doctor finds love with a talented, handsome younger man—who happens to be her patient</b><br/>Hilary Mansell is a talented young doctor, but she is unlucky in love and still recovering from losing out on a keenly sought appointment, one that was awarded to none other than her former lover. A new position in the scenic Cotswolds offers the balm of tranquillity. But life proves less than placid when Hilary meets Julian on her hospital rounds. He is attractive, intelligent, and recovering from a riding injury. He is also much younger than Hilary and dealing with an overbearing mother.<br/>The two lovers are captured in unforgettable richness by Mary Renault’s pen. The intimacy of their feelings, the nuances of romance, and the cadence of pitch-perfect dialogue render <i>Return to Night</i> a love story like no other.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mary Renault
      </h2>
      
      <p class="authorDescription body article">Born in London as Eileen Mary Challans in 1905 and educated at the University of Oxford, Mary Renault trained as a nurse at Oxford's Radcliffe Infirmary. It was there that she met her lifelong partner, fellow nurse Julie Mullard. After completing her training, Renault wrote her first novel,&#160;<I>Purposes of Love</I>, in 1937. In 1948, after her novel&#160;<I>Return to Night</I>&#160;won an MGM prize worth $150,000, she and Mullard immigrated to South Africa. There, Renault wrote the historical novels that would define her career. In 2006, Renault was the subject of a BBC 4 documentary, and her books, many of which remain in print on both sides of the Atlantic, are often sought after for radio and dramatic interpretation. In 2010,&#160;<I>Fire From Heaven&#160;</I>was shortlisted for the 1970 Lost Booker prize.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c0f8fd70